import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { AlertService } from './alert.service';
import { Subscription } from 'rxjs';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.css'],
    standalone: false
})
export class AlertComponent implements OnInit {
  messageType: string;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public message: any, private _snackRef: MatSnackBarRef<AlertComponent>) { }

  ngOnInit() {
  }

  dismiss(){
    this._snackRef.dismiss();
  }
  

}
